/**
 * Comparators shared across the dashboards surfaces.
 *
 * `byName` existed three times — in the scope picker, in Overview's roster
 * column model and in the Venues one — each a locale-aware compare with the
 * same options for the same reason. Three definitions of "alphabetical" for
 * lists a reader moves between is three chances for them to disagree.
 */

/**
 * Locale-aware and case-insensitive, so accented names file where a reader
 * expects them and "de Young" sorts where they look for it.
 */
export const byName = (a: { name: string }, b: { name: string }): number =>
  a.name.localeCompare(b.name, undefined, { sensitivity: 'base' });
